import { FaChurch, FaUsers, FaFemale, FaChild, FaUserGraduate, FaPrayingHands, FaHandsHelping } from "react-icons/fa";

const ministries = [
  {
    icon: <FaChurch />,
    title: "Sunday Worship Service",
    purpose: "To gather as one body in Christ for worship, teaching, prayer, and fellowship.",
    about:
      "Our Sunday Worship Service is the heart of church life at Moriah Church. Through Spirit-led worship, biblical preaching, and corporate prayer, believers are refreshed, encouraged, and equipped to live out their faith in everyday life.",
    focus: [
      "Worship and praise",
      "Teaching rooted in God’s Word",
      "Prayer for individuals and families",
      "Fellowship and community",
    ],
  },
  {
    icon: <FaUsers />,
    title: "Youth Ministry",
    purpose: "To disciple and equip young people to live boldly for Christ.",
    about:
      "The Youth Ministry provides a nurturing and engaging environment where young people grow in faith, character, and leadership. Through Bible teaching, mentorship, and fellowship, we guide youth to discover their identity and purpose in Christ.",
    focus: [
      "Discipleship and spiritual growth",
      "Leadership development",
      "Biblical guidance for life challenges",
      "Fellowship and mentorship",
    ],
  },
  {
    icon: <FaFemale />,
    title: "Women’s (Ladies) Ministry",
    purpose: "To empower women to realize their God-given calling and actively serve in ministry.",
    about:
      "Our Women’s Ministry is a supportive and prayerful community where women grow spiritually, encourage one another, and develop leadership rooted in God’s Word.",
    focus: [
      "Bible study and prayer",
      "Spiritual and personal growth",
      "Leadership and service",
      "Fellowship and encouragement",
    ],
  },
  {
    icon: <FaChild />,
    title: "Children’s Ministry / Sunday School",
    purpose: "To build a strong biblical foundation in the lives of children.",
    about:
      "Our Children’s Ministry teaches God’s Word in a joyful, safe, and age-appropriate way, nurturing children in faith and Christ-like character.",
    focus: [
      "Bible stories and foundational truths",
      "Worship and prayer for children",
      "Moral and character development",
      "Loving and secure environment",
    ],
  },
  {
    icon: <FaUserGraduate />,
    title: "Discipleship & Leadership Development",
    purpose: "To equip believers to grow spiritually and lead with integrity and purpose.",
    about:
      "This ministry focuses on developing mature disciples and godly leaders through teaching, mentoring, and training.",
    focus: [
      "Biblical doctrine and spiritual maturity",
      "Leadership training and mentoring",
      "Servant leadership modeled after Christ",
      "Ministry readiness",
    ],
  },
  {
    icon: <FaPrayingHands />,
    title: "Prayer Ministry",
    purpose: "To seek God’s presence and power through prayer.",
    about:
      "Prayer is central to everything we do at Moriah Church. This ministry encourages believers to grow in personal and corporate prayer.",
    focus: [
      "Corporate prayer meetings",
      "Intercession and spiritual support",
      "Healing and encouragement",
      "Dependence on God",
    ],
  },
  {
    icon: <FaHandsHelping />,
    title: "Community Outreach",
    purpose: "To demonstrate Christ’s love through service and compassion.",
    about:
      "Our Community Outreach Ministry serves people with humility and care through evangelism, social support, and acts of compassion.",
    focus: [
      "Evangelism and Gospel outreach",
      "Community service initiatives",
      "Compassionate care",
      "Building relationships",
    ],
  },
];

export default function MinistriesSection() {
  return (
    <section className="w-full bg-white px-6 py-20" data-aos="fade-up">
      <div className="max-w-6xl mx-auto space-y-16">

        {/* Heading */}
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1A1F2B]">
            Our Ministries
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Every ministry works together to fulfill God’s mission—building
            believers, nurturing families, and impacting lives for Christ.
          </p>
        </div>

        {/* Ministries */}
        <div className="grid md:grid-cols-2 gap-10">
          {ministries.map((ministry, index) => (
            <div
              key={index}
              className="bg-[#F5E9D8] rounded-2xl p-8 shadow-md space-y-5 hover:shadow-lg transition"
            >
              <div className="flex items-center gap-3 text-[#D9A05B] text-2xl">
                {ministry.icon}
                <h3 className="text-2xl font-semibold text-[#1A1F2B]">
                  {ministry.title}
                </h3>
              </div>

              <p className="text-lg text-black">
                <span className="font-semibold">Purpose: </span>
                {ministry.purpose}
              </p>

              <p className="text-lg text-gray-700 leading-relaxed">
                {ministry.about}
              </p>

              <ul className="list-disc list-inside space-y-2 text-lg text-gray-800">
                {ministry.focus.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Closing Statement */}
        <div className="text-center max-w-4xl mx-auto pt-10">
          <p className="text-xl italic text-[#1A1F2B]">
            At Moriah Church, every ministry works together to fulfill God’s
            mission—building strong believers, nurturing families, empowering
            leaders, and impacting the world for Christ. We invite you to grow,
            serve, and walk with us as we pursue the fullness of life in Jesus
            Christ.
          </p>
        </div>
      </div>
    </section>
  );
}
